import React from 'react';
import moment from 'moment'
import { DATE_FORMAT } from '../../constants';

export const MIS_FIELD_FORM_CATEGORY = ['CASE_RECIEPT', 'CASE_BILLING', 'CASE_PROCESSING'];
export const MIS_FIELD_KEY_TYPE = ['OBJECT_LIST', 'SIMPLE'];
export const MIS_FIELD_DATA_TYPE = ['NUMERIC', 'DATE', 'ALPHANUMERIC'];
export const MIS_FIELD_TYPE = ['DOMESTIC', 'INTERNATIONAL','BUYIN','ALL','DEBT_COLLECTION'];

export const DEFAULT_CHECKBOX_VALUES = [
    {
        label: 'OBJECT_LIST',
        value: false,
        type: 'keyType'
    },
    {
        label: 'SIMPLE',
        value: false,
        type: 'keyType'
    },
    {
        label: 'DATE',
        value: false,
        type: 'dataType'
    },
    {
        label: 'NUMERIC',
        value: false,
        type: 'dataType'
    },
    {
        label: 'ALPHANUMERIC',
        value: false,
        type: 'dataType'
    },
    {
        label: 'CASE_RECIEPT',
        value: false,
        type: 'formCategory'
    },
    {
        label: 'CASE_PROCESSING',
        value: false,
        type: 'formCategory'
    },
    {
        label: 'CASE_BILLING',
        value: false,
        type: 'formCategory'
    }
]
export const TABLE_COLUMNS = [
    {
        Header: 'Name',
        id: 'name',
        accessor: p => <div>{p.name}</div>,
        maxWidth: 300
    },
    {
        Header: 'Data Type',
        accessor: 'data.dataType',
    },
    {
        Header: 'Key Type',
        accessor: 'keyType',
    },
    {
        Header: 'Form Category',
        accessor: 'formCategory',
    },
    {
        Header: 'Values',
        accessor: p => <div>{(p.data.values) ? p.data.values.join(',') : ''}</div>,
        id: 'values',
        maxWidth: 300
    },
    {
        Header: 'Field Type',
        accessor: 'fieldType',
    },
    {
        Header: 'Master Key',
        accessor: 'masterKey',
    },
    {
        Header: 'Created On',
        id: 'createdAt',
        accessor: p => <div title={p.createdAt}>{moment(p.createdAt).format(DATE_FORMAT)}</div>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title).getTime();
            b = new Date(b.props.title).getTime();
            if (b > a) return 1;
            else if (b < a) return -1;
            else if (b === a) return 0;
        }
    }
];

export const DEFAULT_SORTING = {
    id: 'name',
    desc: true
}
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_REQUEST_BODY = {
    paginatedData: {
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        sortfield: 'name',
        sortDirection: 'desc'
    },
    requestData: {
        name: '',
        keyTypes: [],
        dataTypes: [],
        formCategories: []
    }
}

export const ENTER = 'Enter';